import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAFmKKMOPyZtr6zwvFQswoeUHU0T590xdI',
        libraries: 'places,drawing,visualization,places,geometry',
    },
})